/**
 * 私有化服务配置： https://gateway.wpsgo.com/webpath/drive/wps-private-entry.json
 * @type { String } privateServiceName: 私有化服务配置名称，详细配置见上边链接
 * @type { Array } publicServiceDomain: 私有化服务对应的公网域名
 */
export const domainMappingArr = [
  {
    privateServiceName: "kdocs",
    publicServiceDomain: [
      "wps.cn",
      "www.wps.cn",
      "kdocs.cn",
      "www.kdocs.cn",
      "docs.wps.cn",
      "docs.kdocs.cn",
    ],
  },
  {
    privateServiceName: "account",
    publicServiceDomain: ["account.wps.cn", "account.kdocs.cn"],
  },
  {
    privateServiceName: "drive",
    publicServiceDomain: ["drive.wps.cn", "drive.kdocs.cn"],
  },
  {
    privateServiceName: "form",
    publicServiceDomain: ["f.wps.cn", "f.kdocs.cn"],
  },
  {
    privateServiceName: "formapi",
    publicServiceDomain: ["f-api.wps.cn", "f-api.kdocs.cn"],
  },
  {
    privateServiceName: "rili",
    publicServiceDomain: ["rili.wps.cn", "rili.kdocs.cn"],
  },
  {
    privateServiceName: "todo",
    publicServiceDomain: ["todo.wps.cn", "todo.kdocs.cn"],
  },
  {
    privateServiceName: "roaming",
    publicServiceDomain: ["roaming.wps.cn", "roaming.kdocs.cn"],
  },
  {
    privateServiceName: "plus",
    publicServiceDomain: ["plus.wps.cn", "plus.kdocs.cn"],
  },
  {
    privateServiceName: "work",
    publicServiceDomain: ["work.wps.cn", "work.kdocs.cn"],
  },
  {
    privateServiceName: "weboffice",
    publicServiceDomain: ["web.wps.cn", "web.kdocs.cn"],
  },
  {
    privateServiceName: "open",
    publicServiceDomain: ["open.wps.cn", "open.kdocs.cn"],
  },
  {
    privateServiceName: "openapi",
    publicServiceDomain: ["openapi.wps.cn", "openapi.kdocs.cn"],
  },
  {
    privateServiceName: "plussvr",
    publicServiceDomain: ["plussvr.wps.cn", "plussvr.kdocs.cn"],
  },
  {
    privateServiceName: "securitydoc",
    publicServiceDomain: ["securitydoc.wps.cn", "securitydoc.kdocs.cn"],
  },
  {
    privateServiceName: "wpsplus",
    publicServiceDomain: ["wpsplus.com"],
  },
  {
    privateServiceName: "qwps",
    publicServiceDomain: ["qwps.com"],
  },
  {
    privateServiceName: "yun",
    publicServiceDomain: ["yun.wps.cn", "yun.kdocs.cn"],
  },
  {
    privateServiceName: "msgcenter",
    publicServiceDomain: ["msgcenter.wps.cn", "msgcenter.kdocs.cn"],
  },
  {
    privateServiceName: "ksopushLoginWeb",
    publicServiceDomain: ["loginweb.wps.cn", "loginweb.kdocs.cn"],
  },
  {
    privateServiceName: "avatar",
    publicServiceDomain: ["avatar.wps.cn", "avatar.kdocs.cn", "vatar.qwps.cn"],
  },
  {
    privateServiceName: "docserver",
    publicServiceDomain: ["docserver.wps.cn", "docserver.kdocs.cn"],
  },
  {
    privateServiceName: "ecis",
    publicServiceDomain: ["ecis.wps.cn"],
  },
  {
    privateServiceName: "woa",
    publicServiceDomain: ["woa.wps.cn"],
  },
  {
    privateServiceName: "minio",
    publicServiceDomain: ["minio.wps.cn", "minio.kdocs.cn"],
  },
  {
    privateServiceName: "qn",
    publicServiceDomain: ["qn.cache.wpscdn.cn"],
  },
  {
    privateServiceName: "meeting",
    publicServiceDomain: ["meeting.kdocs.cn"],
  },
  {
    privateServiceName: "vas2t",
    publicServiceDomain: ["vas2t-api.wps.cn", "vas2t-api.kdocs.cn"],
  }
]

const domainMapping = new Map()

for (const conf of domainMappingArr) {
  const privateServiceName = conf["privateServiceName"]
  const publicServiceDomain = conf["publicServiceDomain"]
  for (const domain of publicServiceDomain) {
    if (domainMapping.has(domain)) {
      throw new Error(`已存在相同的domain配置：${domain}`)
    } else {
      domainMapping.set(domain, privateServiceName)
    }
  }
}

export { domainMapping }
